module.exports = __webpack_public_path__ + "img/cookie-bite.33e868d7.svg";